import { render, staticRenderFns } from "./EditIngameAccount.vue?vue&type=template&id=179a8a5f&scoped=true&"
import script from "./EditIngameAccount.vue?vue&type=script&lang=ts&"
export * from "./EditIngameAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179a8a5f",
  null
  
)

export default component.exports